import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import ProfileCompletion from "../ProfileCompletion/ProfileCompletion";
import Carousel from "./Carousel";
import EmployerDescription from "./EmployerDescription";
import { GlobalStyle } from "../TabNavigation/styles/router-nav-styles";
import slideType from "./types/slideType";
import descriptionType from "./types/descriptionType";
import Theme from "../../theme/theme";
import {
  EmployerProfileWrapper,
  ProfileData,
} from "./styles/employer-profile-styles";
import { SettingsRoutes } from "../../routes";
import { isFeatureEnabled } from "../../helpers";

const EmployerProfile = ({
  slides,
  description,
  showProfileCompletion,
  isRecruiter,
  showAvgResponseTime,
  isPortalEmployer,
  isPremiumEmployer,
}) => {
  const { companyName } = description;
  const progressItems = [
    {
      data: slides[0],
      name: "title image",
      link: isFeatureEnabled("employerSettingsSliceTwo")
        ? SettingsRoutes.CompanyOverview
        : "/profile/company/edit",
    },
    {
      data: description.logo,
      name: "company logo",
      link: isFeatureEnabled("employerSettingsSliceTwo")
        ? SettingsRoutes.CompanyOverview
        : "/profile/company/edit",
    },
    {
      data: description.website,
      name: "company website",
      link: isFeatureEnabled("employerSettingsSliceTwo")
        ? SettingsRoutes.CompanyOverview
        : "/profile/company/edit",
    },
    {
      data: description.socialLinks[0],
      name: "social links",
      link: isFeatureEnabled("companySocialsManagement")
        ? SettingsRoutes.CompanySocials
        : "/profile/company/edit",
    },
    {
      data: description.employeesCount,
      name: "employees",
      link: isFeatureEnabled("employerSettingsSliceTwo")
        ? SettingsRoutes.CompanyOverview
        : "/profile/company/edit",
    },
    {
      data: description.city,
      name: "city",
      link: isFeatureEnabled("companyLocationManagement")
        ? SettingsRoutes.CompanyLocation
        : "/profile/company/edit",
    },
    {
      data: description.postalAddress,
      name: "postcode",
      link: isFeatureEnabled("companyLocationManagement")
        ? SettingsRoutes.CompanyLocation
        : "/profile/company/edit",
    },
    {
      data: description.about,
      name: "company description",
      link: "/profile/company/edit",
    },
    isFeatureEnabled("emailDomainManagement") && {
      data: description.emailDomains?.[0],
      name: "email domain",
      link: SettingsRoutes.EmailDomains,
    },
  ].filter((item) => Boolean(item));

  return (
    <ErrorBoundary>
      <Theme>
        <GlobalStyle />
        <EmployerProfileWrapper isRecruiter={isRecruiter}>
          {showProfileCompletion && (
            <ProfileCompletion
              noSlides={slides.length === 0}
              progressItems={progressItems}
              marginTop
              showAddButton
            />
          )}
          {slides.length > 0 && (
            <Carousel slides={slides} companyName={companyName} />
          )}
          <ProfileData noSlides={slides.length === 0} isRecruiter={isRecruiter}>
            <EmployerDescription
              description={description}
              showAvgResponseTime={showAvgResponseTime}
              isPortalEmployer={isPortalEmployer}
              isPremiumEmployer={isPremiumEmployer}
              isRecruiter={isRecruiter}
            />
          </ProfileData>
        </EmployerProfileWrapper>
      </Theme>
    </ErrorBoundary>
  );
};

EmployerProfile.propTypes = {
  slides: PropTypes.arrayOf(slideType).isRequired,
  description: descriptionType.isRequired,
  showProfileCompletion: PropTypes.bool.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
  showAvgResponseTime: PropTypes.bool,
  isPortalEmployer: PropTypes.bool,
  isPremiumEmployer: PropTypes.bool,
};

EmployerProfile.defaultProps = {
  showAvgResponseTime: null,
  isPortalEmployer: null,
  isPremiumEmployer: null,
};

export default EmployerProfile;
